import { IS_PROD, IS_SANDBOX_FRONTEND, IS_STAGING_FRONTEND } from "@smartrr/shared/constants";

export function ldGetClientSideId(): string {
  if (IS_SANDBOX_FRONTEND && process.env.LAUNCH_DARKLY_CLIENT_ID_SANDBOX) {
    return process.env.LAUNCH_DARKLY_CLIENT_ID_SANDBOX;
  }

  if (IS_STAGING_FRONTEND && process.env.LAUNCH_DARKLY_CLIENT_ID_STAGING) {
    return process.env.LAUNCH_DARKLY_CLIENT_ID_STAGING;
  }

  if (IS_PROD() && process.env.LAUNCH_DARKLY_CLIENT_ID_PROD) {
    return process.env.LAUNCH_DARKLY_CLIENT_ID_PROD;
  }

  return process.env.LAUNCH_DARKLY_CLIENT_ID_TEST ?? ""; // local dev
}
